import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import type { ClientSummary } from "../api/clientManagement";
import { SectionCard } from "./SectionCard";

interface ClientScopeSelectorProps {
  isCentralAdmin: boolean;
  selectedClientId: string;
  selectedClient: ClientSummary | null;
  clients: ClientSummary[];
  onChange: (clientId: string) => void;
}

export const ClientScopeSelector: React.FC<ClientScopeSelectorProps> = ({
  isCentralAdmin,
  selectedClientId,
  selectedClient,
  clients,
  onChange,
}) => {
  if (!isCentralAdmin) return null;

  return (
    <SectionCard
      title="Client scope"
      description="Pick a client to manage branding, departments, roles, and users."
    >
      <FormControl size="small" sx={{ maxWidth: 360 }}>
        <Select
          value={selectedClientId}
          displayEmpty
          onChange={(event) => onChange(event.target.value)}
          renderValue={(value) => {
            if (!value) return "Select a client";
            return selectedClient?.name ?? value;
          }}
        >
          <MenuItem value="">
            <em>Select a client</em>
          </MenuItem>
          {clients.map((client) => (
            <MenuItem key={client.id} value={client.id}>
              {client.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </SectionCard>
  );
};
